import { Component, OnInit, ViewChild } from '@angular/core';
import { CrosstrendService } from 'src/app/services/crosstrend.service';
import * as Highcharts from 'highcharts';
import { TradingSystemSummary } from 'src/app/models/trading-system-summary';
import { TradingSystemGraficoWeeklyComponent } from '../../shared/trading-system-grafico-weekly/trading-system-grafico-weekly.component';
import { CommonModule } from '@angular/common';
import { HighchartsChartModule } from 'highcharts-angular';
import { TradingSystemSummaryComponent } from '../../shared/trading-system-summary/trading-system-summary.component';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';

@Component({
  selector: 'app-backtest-m15',
  standalone: true,
  templateUrl: './backtest-m15.component.html',
  styleUrls: ['./backtest-m15.component.scss'],
  imports: [
    TradingSystemGraficoWeeklyComponent, CommonModule,
    HighchartsChartModule, TradingSystemSummaryComponent,
    MdbSelectModule
  ]
})
export class BacktestM15Component implements OnInit {

  chartOptions: Highcharts.Options = {}
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false

  mercati: any[] = []
  selezionato: string = ''
  ts!: TradingSystemSummary
  //titolo: string = ''
  @ViewChild('chartWeek') chartWeek!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartBuy') chartWeekBuy!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartSell') chartWeekSell!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonth') chartMonth!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonthlyBuy') chartMonthlyBuy!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonthlySell') chartMonthSell!: TradingSystemGraficoWeeklyComponent

  constructor(private serv: CrosstrendService) { }

  ngOnInit(): void {
    this.serv.listaMercati().subscribe((data: any) => {
      console.log(data)
      this.mercati = data.data.filter((el: any) => el.tipo == 'Major' || el.tipo == 'Cross')
    })
  }

  cambiaMercato(market: string) {
    this.selezionato = market
    this.serv.listaCrossTrendM15(market).subscribe((data: any) => {
      console.log(data)
      if (data.res == 'ok') {
        data.data.map((el: any) => { el .punti= el.profit})
        this.chartWeek.caricaDati(data.data)
        this.chartWeekBuy.caricaDati(data.data.filter((el:any)=> el.verso=='buy'))
        this.chartWeekSell.caricaDati(data.data.filter((el:any)=> el.verso=='sell'))
        this.chartMonth.caricaDatiMese(data.data)
        this.chartMonthlyBuy.caricaDatiMese(data.data.filter((el:any)=> el.verso=='buy'))
        this.chartMonthSell.caricaDatiMese(data.data.filter((el:any)=> el.verso=='sell'))
        this.ts = new TradingSystemSummary().popolaDati(market, this.mercati.find((el:any)=> el.market==market).pip, data.data)
        this.ts.spread = this.mercati.find((el:any)=> el.market==market).spread
        this.aggiornaGrafico(data.data)
      }
    })
  }

  aggiornaGrafico(data: any) {
    let s1 = data.map((el: any) =>  [el.ora,el.prog])
    let s2 = data.map((el: any) =>  [el.ora, parseFloat(el.close)])
    this.chartOptions = {
      title: {
        text: 'Backtest M15'
      },
      chart: {
        zooming: {
          type: 'x'
        }
      },
      series: [{
        name: 'Progressivo',
        data: s1,
        type: 'line',
        color: 'lime',
        turboThreshold: 4000
      }, {
        name: this.selezionato,
        data: s2,
        type: 'line',
        dashStyle: 'ShortDot',
        yAxis: 1,
        turboThreshold: 4000
      }],
      yAxis: [
        {
          title: {
            text: 'Progressivo'
          }
        },
        {
          title: {
            text: 'Cambio'
          },
          opposite: true
        }
      ],
    }
    this.updateFlag = true
  }

}
